import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import CountUp from "react-countup";
import { apiBaseURL } from "../../utils/axios";
import { Helmet } from "react-helmet";

const Insight = () => {
  const [count, setCount] = useState([]);
  const [request, setRequest] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behaviour: "smooth",
    });
  }, []);

  const getCount = async () => {
    try {
      const res = await axios.get(`${apiBaseURL}/v1/donors`);
      const response = await axios.get(
        `${apiBaseURL}/v1/patients/request-count`
      );

      setCount(res.data.result);
      setRequest(response.data.numberOfRequests);
    } catch (error) {
      console.log(error);
    }
  };
  // const donorUrl = `${apiBaseURL}/v1/donors`;
  // const requestUrl = `${apiBaseURL}/v1/patients/request-count`;
  // const getDonor = axios.get(donorUrl);
  // const getRequest = axios.get(requestUrl);
  // axios
  //   .all([getDonor, getRequest])
  //   .then(
  //     axios.spread((...allData) => {
  //       const allDonor = allData[0].data.result;
  //       const allRequest = allData[1].data;

  //       setCount(allDonor);
  //
  //       setRequest(allRequest);
  //     })
  //   )
  //   .catch((err) => {
  //     console.log(err);
  //   });
  // try {
  //   const res = await `${apiBaseURL}/v1/donors`;
  //   const resp = await `${apiBaseURL}/v1/patients/request-count;

  //   setDonorCount(res.data.donorsCount);
  //   setRequestCount(resp.data.numberOfRequests);
  // } catch (error) {
  //   console.log(error);
  // }

  useEffect(() => {
    getCount();

    // eslint-disable-next-line
  }, []);

  return (
    <section className="mx-auto max-w-[1380px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Insights | RIBI BLOOD</title>
        <link rel="canonical" href="https://ribiblood.com/insights" />
      </Helmet>
      {/* Top Hero */}

      <section className="shadow border-t-2 border-slate-200">
        {/* <div className={styles.imageContainer}> */}
        <div className="flex justify-center items-center text-center py-32 lg:px-4 px-8">
          {" "}
          <p className=" text-[#f6655f] text-4xl leading-normal font-bold">
            KNOW MORE ABOUT BLOOD DONATED AND REQUESTED{" "}
          </p>
        </div>
      </section>

      <div className="insight grid place-items-center px-5 md:px-10 py-24 ">
        <div className="text-center">
          <div className="my-5">
            <h4 className="text-4xl font-bold">
              Details about our contributors
            </h4>
            <p className="my-5 md:my-2">Participants so far!</p>
          </div>
          <div className="figures grid grid-cols-1 lg:grid-cols-2 gap-4 w-fit justify-center font-bold mx-auto pt-12 pb-16 md:flex-row">
            <div className="donors bg-black h-about md:mr-5 my-5 md:my-0 p-2 w-[280px] flex flex-col justify-evenly rounded-lg h-[180px]">
              <h4 className="text-white text-3xl my-2">Donors</h4>
              <p className="text-blue-700 text-6xl">
                <CountUp start={0} end={count} />
              </p>
            </div>
            <div className="donees bg-black p-2 h-[180px] w-[280px] flex flex-col justify-evenly rounded-lg h-about mb-12 lg:mb-0">
              <h4 className="text-white text-3xl my-2">Requests</h4>
              <p className="text-green-700 text-6xl">
                <CountUp start={0} end={request} />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Insight;
